<template>
  <transition name="fade">
    <div v-if="visible" class="overlay-wrapper">
      <div class="overlay-content">
        <slot></slot>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "Overlay",
  data() {
    return {
      visible: false,
    };
  },
  mounted() {
    this.visible = true;
    document.querySelector(".sw-Body_Inner").classList.add("overflow-hidden");
  },
  beforeDestroy() {
    document.querySelector(".sw-Body_Inner").classList.remove("overflow-hidden");
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.fade-enter-active,
.fade-leave-active {
  transition: opacity $transition-duration;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.overlay-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  z-index: $zi-mobilenav;
}

.overlay-content {
  position: relative;
  display: flex;
  width: 100%;
}
</style>
